import { render, staticRenderFns } from "./ClientNoteContainer.vue?vue&type=template&id=7a0d2fba&scoped=true&"
import script from "./ClientNoteContainer.vue?vue&type=script&lang=js&"
export * from "./ClientNoteContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0d2fba",
  null
  
)

export default component.exports